import { ReactElement } from 'react';
import {
  CloseButton, ModalOverlay,
} from 'components/BaseModal/styles';
import { useModalControl } from 'hooks/useModalControl';
import { CloseModalX, Diamond1Icon } from 'icons';
import { colors } from 'styles/colors';
import {
  ModalHeader, ModalContent, ModalContainer, Button,
} from './styles';
import { useTranslation } from 'react-i18next';
import { COMERCIAL_EMAIL } from './constants';

interface UpgradeModuleModalProps {
  isOpen: boolean;
  title: string;
  subTitle: string;
  description: string;
  buttonLabel: string;
  onClose: () => void;
}

export function UpgradeModuleModal({
  buttonLabel,
  description,
  isOpen,
  title,
  subTitle,
  onClose,
}: Readonly<UpgradeModuleModalProps>): ReactElement | null {
  const { t } = useTranslation();
  const { modalReference } = useModalControl(isOpen, onClose);

  const emailLink = `mailto:${COMERCIAL_EMAIL}?subject=${t('upgradeModulosVisaoGeral').replace(' ', '%20')}`;

  if (!isOpen) return null;

  return (
    <ModalOverlay isOpen={isOpen}>
      <ModalContainer ref={modalReference} data-testId="upgrade-module-modal">
        <ModalHeader>
          <div>
            <Diamond1Icon color={colors.icon['primary-base']} />
            <h3>{t('upgrade')}</h3>
          </div>
          <CloseButton onClick={onClose}>
            <CloseModalX />
          </CloseButton>
        </ModalHeader>
        <ModalContent>
          <h4>{title}</h4>
          <h5>{subTitle}</h5>
          <p>{description}</p>
          <a
            href={emailLink}
            target="_blank"
            data-testId="email-link"
            rel="noreferrer"
          >
            <Button
              type="button"
              variant="primary-filled"
            >
              {buttonLabel}
            </Button>
          </a>
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
}
